import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import type { ReactElement } from "react";
import platformData from "../data/pages/platform.json";
import { AccordionSection } from "../components/AccordionSection/AccordionSection";
import { MdaiTable } from "../components/MdaiTable";
import { PageTemplate } from "../components/PageTemplate";
import type { PlatformPageTemplate } from "../types/platformPageTemplate";
import { resolveCdnAssetUrl } from "../utils/cdnAssetUrl";

const SMART_HUB_OVERVIEW_URL = resolveCdnAssetUrl("home/arch-overview.png");
const SMART_HUB_LIVE_URL = resolveCdnAssetUrl("home/smart-hub-restart.mp4");
const SMART_HUB_HERO_ICON_URL = resolveCdnAssetUrl("solutions/smart-hub.png");

const typedPlatformData = platformData as PlatformPageTemplate;

export default function Platform(): ReactElement {
  return (
    <Box>
      <PageTemplate
        id="platform"
        hero={{
          title: typedPlatformData.hero.title,
          titleFlip: true,
          titleVariant: "h1",
          buttons: [
            {
              href: typedPlatformData.hero.buttonHref,
              text: typedPlatformData.hero.buttonText,
              variant: "contained",
            },
          ],
          image: {
            src: SMART_HUB_HERO_ICON_URL,
            alt: "MyDecisive SmartHub Platform",
          },
          subtitle: typedPlatformData.hero.subtitle,
          divider: false,
        }}
        topTabs={{
          caption: (
            <Stack direction={"column"} textAlign="center" margin="auto">
              {typedPlatformData.topTabs.caption
                .split("\n\n")
                .map((paragraph, index) => (
                  <Typography
                    key={`platform-caption-${index.toString()}`}
                    variant="body1"
                    mb={4}
                    alignSelf="center"
                  >
                    {paragraph}
                  </Typography>
                ))}
            </Stack>
          ),
          tabs: [
            {
              src: SMART_HUB_OVERVIEW_URL,
              title: "Conceptual",
              type: "image",
              alt: "Conceptual overview of MyDecisive SmartHub",
            },
            {
              alt: "MyDecisive SmartHub",
              src: SMART_HUB_LIVE_URL,
              title: "Physical",
              type: "video",
            },
          ],
        }}
        sections={
          <>
            <AccordionSection
              overline={typedPlatformData.capabilities.overline}
              description={
                <>
                  {typedPlatformData.capabilities.description
                    .split("\n\n")
                    .map((paragraph, index) => (
                      <Typography
                        key={`platform-capability-description-${index.toString()}`}
                        mb={index < typedPlatformData.capabilities.description.split("\n\n").length - 1 ? 4 : 0}
                      >
                        {paragraph}
                      </Typography>
                    ))}
                </>
              }
              items={typedPlatformData.capabilities.items}
            />
            <MdaiTable
              tableTitle={typedPlatformData.ifttt.title}
              tableSubtitle={typedPlatformData.ifttt.subtitle}
              headers={typedPlatformData.ifttt.headers}
              rows={typedPlatformData.ifttt.rows}
              id="ifttt"
            />
          </>
        }
        bottomButton={typedPlatformData.bottomButton}
      />
    </Box>
  );
}
